import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { fetchBannerState } from '../services/bannerService'
import { RootState } from './store'

interface IBannerState {
  /**
   * If banner should be shown or not
   */
  isShown: boolean
  communications: string
  status: 'idle' | 'loading' | 'failed'
}

const initialState: IBannerState = {
  isShown: false,
  communications: '',
  status: 'idle',
}

export const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    /**
     * Toggle the current state of banner; Hides if already visible
     */
    toggleBanner: (state) => {
      state.isShown = !state.isShown
    },
    /**
     * Explicitly set the show state of banner
     */
    setBannerIsShown: (state, action: PayloadAction<boolean>) => {
      state.isShown = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBannerStateAsync.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchBannerStateAsync.fulfilled, (state, action) => {
        state.status = 'idle'
        state.isShown = action.payload.isShown
        state.communications = action.payload.communications
      })
      .addCase(fetchBannerStateAsync.rejected, (state) => {
        state.status = 'failed'
      })
  },
})

/**
 * Async thunk which will be used to fetch banner state
 *
 * FIXME: Remember to replace with actual API during integration
 */
export const fetchBannerStateAsync = createAsyncThunk(
  'banner/fetchBannerState',
  async ({
    accessToken,
    idToken,
    projectId,
    user_email,
  }: {
    accessToken: string
    idToken: string
    projectId: string
    user_email: string
  }) => {
    const response = await fetchBannerState({ accessToken, idToken, projectId, user_email })
    const json = await response.json()
    console.log(json, 'DATA')
    if (json.communications !== '') return { communications: json.communications, isShown: true }
    return { communications: json.communications, isShown: false }
  },
)

export const { toggleBanner, setBannerIsShown } = bannerSlice.actions
export const selectBannerState = (state: RootState) => state.banner
export default bannerSlice.reducer
